import React, { useEffect, useState } from "react";
import TextAreaField from "../../forms/textarea-field";
import InputField from "../../forms/input-field";
import { useDispatch } from "react-redux";
import SelectField from "../../forms/select-field";
import { stateListAction } from "../../../redux/actions/general-action";

const StoreFirmShopAddressTab = ({ disabled = false }) => {
  const dispatch = useDispatch();

  const [stateList, setStateList] = useState([]);

  useEffect(() => {
    dispatch(stateListAction(onSuccessState, onErrorState));
  }, []);

  const onSuccessState = (data) => {
    setStateList(
      data.map((item) => {
        return { label: item?.name, value: item?.name };
      })
    );
  };
  const onErrorState = () => {};
  return (
    <div className="w-full 2xl:w-[30%] lg:w-[60%] px-5 xl:px-10">
      <TextAreaField
        isDisabled={disabled}
        label="Address "
        placeholder="Street 1"
        name="firm_address"
        id={"firm_address"}
        // isRequired={true}
        labelWidth="8.5rem"
        feildHeight="5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_area"
        placeholder=""
        label="Area"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_landmark"
        placeholder=""
        label="Landmark"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_town_or_village"
        placeholder=""
        label="Town/ Village"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_city"
        placeholder=""
        label="City"
        labelWidth="8.5rem"
      />
      <SelectField
        isDisabled={disabled}
        placeholder={"Select state"}
        options={stateList}
        label={"State"}
        id={"firm_state"}
        name="firm_state"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        // isRequired={true}
        labelWidth="8.5rem"
      />

      <SelectField
        isDisabled={disabled}
        placeholder={"Select country"}
        options={countryList}
        label={"Country/Region"}
        id={"firm_country_region"}
        name="firm_country_region"
        isSearchable={true}
        errMsgContainerClass="ps-2"
        labelWidth="8.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="firm_pin_code"
        placeholder=""
        label="Pin Code"
        labelWidth="8.5rem"
      />
    </div>
  );
};

export default StoreFirmShopAddressTab;

const countryList = [{ label: "India", value: "india" }];
